export default __webpack_public_path__ + "static/media/six.d8875f31.jpeg";